import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";
import { endpoint } from "../../../utils/constants/endpoint";

export const userDocumentsApi = createApi({
  reducerPath: "userDocument",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["documents"],
  endpoints: (builder) => ({
    getDocumentManagement: builder.query({
      query: ({ page, filter, orderDirection, valueToOrderBy }) => ({
        url: `${endpoint.USER_DOCUMENTS.DOCUMENTS}?mainCategoryId=${filter.mainCategoryId}&subCategoryId=${filter.subCategoryId}&dateFrom=${filter.dateFrom}&dateTo=${filter.dateTo}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: {
          startRow: page.startRow,
          endRow: page.endRow,
          sort: [
            {
              colId: valueToOrderBy,
              sortDirection: orderDirection,
              sortIndex: 0,
            },
          ],
        },
      }),
      providesTags: ["documents"],
    }),

    getDocumentById: builder.query({
      query: (id) => ({
        url: `documents/${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      providesTags: ["documents"],
    }),

    editDocument: builder.mutation({
      query: (body) => ({
        url: `documents/${body.id}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: body,
      }),
      invalidatesTags: ["documents"],
    }),

    deleteDocument: builder.mutation({
      query: (id) => ({
        url: `documents/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
      invalidatesTags: ["documents"],
    }),
    deleteAllDocuments: builder.mutation({
      query: (ids) => ({
        url: `documents/delete`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: ids,
      }),
      invalidatesTags: ["documents"],
    }),
    createDocument: builder.mutation({
      query: (data) => ({
        url: `documents/create`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
        body: data,
      }),
      invalidatesTags: ["documents"],
    }),
  }),
});

export const {
  useGetDocumentManagementQuery,
  useGetDocumentByIdQuery,
  useEditDocumentMutation,
  useDeleteDocumentMutation,
  useCreateDocumentMutation,
  useDeleteAllDocumentsMutation,
} = userDocumentsApi;
